import { nullable, object, string, type } from "superstruct";

export const ShopBrandInfoSchema = object({
    logoUrl: nullable(string()),
});

export const AdditionalShopBrandInfoSchema = type({
    GW_SHOP_BRAND_INFO: ShopBrandInfoSchema,
});
